import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, GridItem } from '@coolblue-development/freddy';
import selectEntranceTrigger from '@coolblue-development/ga4-events/triggers/ContentBlocks/ImageEntrances/selectEntranceTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { EntranceDisplay } from '../../../../types.js';
import { Entrance } from '../../Shared/index.js';
import { getPropertyFromLink } from '../../utils/index.js';
import { MobileEntranceWithDescription } from './MobileEntranceWithDescription.js';
import { QuestionnaireEntrance } from './QuestionnaireEntrance.js';
export const EntranceFactory = ({ entrances, imageLoadingStrategy = 'lazy', ...analyticsProps }) => {
    const twoEntrances = entrances.entrances.length === 2;
    const displayStyle = entrances.displayStyle;
    const withDescription = displayStyle === EntranceDisplay.WithDescription;
    const image2EntrancesColumn = {
        xs: withDescription ? 'span 12' : 'span 6',
        md: 'span 6',
        lg: 'span 3',
    };
    const image4EntrancesColumn = withDescription ? { xs: 'span 12', md: 'span 6' } : 'span 6';
    const column = twoEntrances ? image2EntrancesColumn : image4EntrancesColumn;
    const { trackEvent } = useAnalytics();
    function handleEntranceClick(entrance, index) {
        trackEvent(selectEntranceTrigger({
            index,
            total_indices: entrances.entrances.length,
            correlation_id: analyticsProps.correlation_id || '',
            sub_feature: twoEntrances ? 'two_entrances' : 'four_entrances',
            url: getPropertyFromLink('absoluteUrl', entrance.link),
            redirect: getPropertyFromLink('title', entrance.link),
        }));
    }
    return entrances.entrances.map((entrance, entranceIndex) => (_jsxs(GridItem, { column: column, children: [_jsx(Box, { hideUntil: withDescription ? 'md' : undefined, sx: { height: '100%', width: '100%' }, children: entrance.__typename === 'HemingwayEntranceGuidedQuestionnaireV3' ? (_jsx(QuestionnaireEntrance, { displayStyle: displayStyle, entrance: entrance, onClick: () => handleEntranceClick(entrance, entranceIndex) })) : (_jsx(Entrance, { entrance: entrance, displayStyle: displayStyle, withDescription: withDescription, onClick: () => handleEntranceClick(entrance, entranceIndex), imageLoadingStrategy: imageLoadingStrategy, imageSizes: "(min-width: 1420px) 306px, (min-width: 1040px) calc(20vw + 26px), calc(50vw - 34px)", ...analyticsProps })) }), withDescription && _jsx(MobileEntranceWithDescription, { entrance: entrance })] }, entranceIndex)));
};
//# sourceMappingURL=EntranceFactory.js.map